export default "__VITE_ASSET__DsFZvG0C__"